@if (parentCategories.length && parentCategories[0].isVisible) {
  <mat-expansion-panel hideToggle class="category-filter box-shadow"
    [expanded]="true" (closed)="categoryExpanded = false"
    (opened)="categoryExpanded = true">
    <mat-expansion-panel-header>
      <mat-panel-title>{{ 'globalUi.filter.categoryLevel1' | translate }}</mat-panel-title>
      <mat-panel-description fxFlex="">
        <span fxFlex=""></span>
        @if (!categoryExpanded) {
          <img alt=""  src="../../../../assets/icons/close-icon.svg">
        } @else {
          <img alt="" src="../../../../assets/icons/close-icon.svg" >
        }
      </mat-panel-description>
    </mat-expansion-panel-header>
    @for (category of parentCategories; track category) {
      <ng-container class="cat-content">
        <input title="input"
          class="input"
          type="radio"
          name="parent-category"
          [id]="category.id"
          [checked]="category.id === this.selectedCategoryId "
          (change)="selectCategory(category)"
          />
        <label class="label" [for]="category.id"> {{ category.label }} </label>
      </ng-container>
    }
  </mat-expansion-panel>
}

<app-child-categories-filter></app-child-categories-filter>
